export const PORTFOLIO_SCORE_FIELD = 'latestAiScore';
export const PORTFOLIO_SCORE_VERSION = 1;

const finiteNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const compactText = (value, maxLength) => String(value || '').trim().slice(0, maxLength);

export const normalizeStoredPortfolioScore = (value) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;

  const score = finiteNumber(value.score);
  const maxScore = finiteNumber(value.maxScore);
  if (score === null || maxScore === null || maxScore <= 0) return null;

  const safeScore = Math.max(0, Math.min(score, maxScore));
  const calculatedPercentage = (safeScore / maxScore) * 100;
  const suppliedPercentage = finiteNumber(value.percentage);

  return {
    version: PORTFOLIO_SCORE_VERSION,
    score: Math.round(safeScore),
    maxScore: Math.round(maxScore),
    percentage: Math.round(Math.max(0, Math.min(
      suppliedPercentage ?? calculatedPercentage,
      100
    ))),
    ratingLabel: compactText(value.ratingLabel, 100),
    summary: compactText(value.summary, 1200),
    scoredAt: compactText(value.scoredAt, 50),
  };
};

export const createStoredPortfolioScore = (scoreResult, scoredAt = new Date()) => {
  const normalized = normalizeStoredPortfolioScore({
    ...scoreResult,
    scoredAt: scoredAt instanceof Date ? scoredAt.toISOString() : scoredAt,
  });

  if (!normalized) {
    throw new Error('A valid portfolio score is required before it can be saved.');
  }

  return normalized;
};

export const getPortfolioScoreBadgeClass = (percentage) => {
  if (percentage >= 100) return 'text-bg-success';
  if (percentage >= 85) return 'text-bg-primary';
  if (percentage >= 70) return 'text-bg-info';
  if (percentage >= 50) return 'text-bg-warning';
  return 'text-bg-danger';
};
